import { Utils } from "@/plugins/utils";

export default {
	namespaced: true,
	state: {
		
	},
	getters: {
	
	},
	mutations: {
	
	},
	actions: {
		async printReportSalesByPeriod(store, params){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Order/Sales/PrintReportSalesByPeriod", params)
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);

				if(relatPath)
					store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })
				
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async printReportProductsSoldByPeriod(store, params){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Order/Sales/PrintReportProductsSoldByPeriod", params)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);

				if(!!payload.relatPath)
					store.dispatch("print/openRelatsPath", [ payload.relatPath ], { root: true })

				if (!!params.excel && !!payload.excelPath)
					store.dispatch("print/exportedFile", payload.excelPath , { root: true })
				
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async printReportSalesRanking(store, params){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Order/Sales/PrintReportSalesRanking", params)
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);

				if(relatPath)
					store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })
				
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async printReportProductsSoldByVendor(store, params){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Order/Sales/PrintReportProductsSoldByVendor", params)
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);

				if(relatPath)
					store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })
				
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
	}
}